var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-banner-img",class:{ 'header-banner-img--visible': _vm.visible },style:({ backgroundImage: `url(${_vm.src})` })})
}
var staticRenderFns = []

export { render, staticRenderFns }